/* Hero-Slideshow: Crossfade-Karussell mit Autoplay, Balken-Indikator, Pause bei Hover/Fokus/Tab-Wechsel.
   Taktgeber ist die CSS-Fuellanimation der aktiven Indikator-Bar (hero-dot-fill, Dauer --hero-interval):
   animationend -> naechster Slide. Eine Uhr fuer Bar UND Wechsel (kein setInterval, kein Drift);
   Pause friert den Fortschritt per animation-play-state ein (Klasse hero-banner--paused) und laeuft
   danach weiter. Manuelle Navigation startet die Bar des neuen Slides bei 0 (is-active wandert,
   Animation beginnt frisch); die alte Bar wird gecancelt (animationcancel, kein Doppel-Wechsel).
   Slide-Defer: Bilder der Slides 2+ kommen als data-src/data-srcset aus dem Liquid (gestapelt im
   Viewport -> natives lazy greift nicht) und werden EINZELN hydriert, immer einen Schritt voraus
   (Audit 2026-10 PERF-20, docs/decisions.md 2026-10-06): mit laufendem Autoplay nach dem Load des
   LCP-Bilds von Slide 1 (Sicherheitsnetze error/window.load) nur Slide 2, danach bei jedem Wechsel
   der jeweils naechste. Ohne Autoplay (Setting aus oder prefers-reduced-motion) laedt beim Landen
   nichts nach, erst ein manueller Wechsel hydriert sein Ziel. Ein Wechsel auf ein noch nicht
   geladenes Bild wartet dessen load/error ab, bevor der Slide is-active wird (kein Crossfade ins
   Leere); Pfeile/Punkte waehrend der Wartezeit zielen vom angeforderten Slide aus weiter.
   Markup: sections/hero-banner.liquid. Nur geladen auf der Startseite (layout/theme.liquid). */
(function () {
  function initHero(hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var texts = hero.querySelectorAll('[data-hero-text]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var count = slides.length;
    if (count < 2) return; // ein Slide -> nichts zu rotieren

    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rotiert = autoplay && !reduceMotion;
    var current = 0;
    // Zuletzt angeforderter Slide: weicht von `current` nur ab, solange ein Wechsel
    // auf das Laden seines Bildes wartet. Pfeile/Swipe/Autoplay rechnen von hier aus.
    let angefordert = 0;

    // Ein vertagtes Slide-Bild (data-src/data-srcset) hydrieren. Idempotent; srcset vor
    // src, damit der Browser direkt die passende Kandidatenbreite waehlt.
    function hydrate(i) {
      const img = slides[i] ? slides[i].querySelector('img[data-src]') : null;
      if (!img) return;
      img.srcset = img.getAttribute('data-srcset') || '';
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    }
    // Den Slide nach i vorhalten — nur bei laufendem Autoplay, denn nur dann steht
    // der naechste Wechsel sicher bevor (manuell kann es jede Richtung sein).
    function vorhalten(i) {
      if (rotiert) hydrate((i + 1) % count);
    }

    var firstImg = slides[0] ? slides[0].querySelector('img') : null;
    if (rotiert) {
      let gestartet = false;
      const start = function () {
        if (gestartet) return;
        gestartet = true;
        vorhalten(0);
      };
      if (firstImg && !firstImg.complete) {
        firstImg.addEventListener('load', start, { once: true });
        firstImg.addEventListener('error', start, { once: true });
        window.addEventListener('load', start, { once: true });
      } else {
        start();
      }
    }

    function activate(list, i, isText) {
      for (var j = 0; j < list.length; j++) {
        var on = j === i;
        list[j].classList.toggle('is-active', on);
        if (on) {
          list[j].removeAttribute('aria-hidden');
        } else {
          list[j].setAttribute('aria-hidden', 'true');
        }
        if (isText) {
          var link = list[j].querySelector('a');
          if (link) link.setAttribute('tabindex', on ? '0' : '-1');
        }
      }
    }

    // Wechsel anfordern: Ziel sofort hydrieren (Sicherheitsnetz, falls es noch nicht
    // vorgehalten war) und erst zeigen, wenn sein Bild da ist — sonst blendete der
    // Crossfade (bzw. unter reduced-motion der harte Schnitt) eine leere Flaeche ein.
    // Eine neuere Anforderung waehrend der Wartezeit loest die aeltere ab.
    function goTo(i) {
      const ziel = (i + count) % count;
      angefordert = ziel;
      hydrate(ziel);
      const img = slides[ziel].querySelector('img');
      if (!img || img.complete) {
        zeigen(ziel);
        return;
      }
      const weiter = function () {
        img.removeEventListener('load', weiter);
        img.removeEventListener('error', weiter);
        if (angefordert === ziel) zeigen(ziel);
      };
      img.addEventListener('load', weiter);
      img.addEventListener('error', weiter);
    }

    function zeigen(ziel) {
      current = ziel;
      vorhalten(current);
      activate(slides, current, false);
      if (texts.length) activate(texts, current, true);
      for (var d = 0; d < dots.length; d++) {
        var on = d === current;
        dots[d].classList.toggle('is-active', on);
        if (on) {
          dots[d].setAttribute('aria-current', 'true');
        } else {
          dots[d].removeAttribute('aria-current');
        }
      }
    }

    function next() { goTo(angefordert + 1); }

    // Autoplay: Klasse schaltet die Fill-Animation der aktiven Bar frei (CSS);
    // deren Ende ist der Wechsel-Impuls. Ohne Autoplay / bei reduced motion
    // bleiben die Bars statisch (aktive voll gold) und nichts rotiert.
    if (rotiert) {
      hero.classList.add('hero-banner--autoplay');
      hero.addEventListener('animationend', function (e) {
        if (e.animationName === 'hero-dot-fill') next();
      });
    }

    function pause() { hero.classList.add('hero-banner--paused'); }
    function resume() { hero.classList.remove('hero-banner--paused'); }

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { goTo(idx); });
      })(d);
    }

    // Pfeile: prev/next; goTo wrappt via (i + count) % count -> infinite in beide Richtungen
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(angefordert - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(angefordert + 1); });

    // Touch-Swipe (Mobile): horizontale Wischgeste -> prev/next (loest die bestehende Crossfade-Logik aus).
    // Passive Listener -> blockieren vertikales Page-Scrollen nicht; nur als Swipe gewertet, wenn horizontal dominiert.
    // Greift auf Bild- UND Textspalte (mobil obere + untere Haelfte); jede Spalte mit eigenem Gesten-State.
    function addSwipe(el) {
      if (!el) return;
      var swipeX = 0, swipeY = 0, swiping = false, didSwipe = false;
      el.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swiping = false; return; }
        swipeX = e.touches[0].clientX;
        swipeY = e.touches[0].clientY;
        swiping = true;
        didSwipe = false;
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        var dx = e.touches[0].clientX - swipeX;
        var dy = e.touches[0].clientY - swipeY;
        if (!didSwipe && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) didSwipe = true;
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - swipeX;
        var dy = t.clientY - swipeY;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? angefordert + 1 : angefordert - 1);
        }
      }, { passive: true });
      // Klick nach echtem Swipe/Drag unterdruecken, sonst feuert Bild-Link / CTA
      el.addEventListener('click', function (e) {
        if (didSwipe) { e.preventDefault(); e.stopPropagation(); didSwipe = false; }
      }, true);
    }
    addSwipe(hero.querySelector('.hero-banner__image-wrap'));
    addSwipe(hero.querySelector('.hero-banner__content'));

    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', resume);
    hero.addEventListener('focusin', pause);
    hero.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { pause(); } else { resume(); }
    });

    // CTA der inaktiven Textebenen aus dem Tab-Fluss nehmen
    if (texts.length) activate(texts, 0, true);
  }

  function init() {
    var heroes = document.querySelectorAll('[data-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
